import { PlayerFactory } from '../player-factory';
import { AudioPlayerStates, ICaptionsItem, IYoutubePlayer, PlayerStates } from '../../../types/common';
import { PlayerManager } from '../manager/playerManager';
import { IPlayerProvider, PlayerProvider } from './playerProvider';
import { getAudioPlayerState, getPlayerState } from '../../../store/general/selectors';
import { getState } from '../../../store';



export class VideoPlayerProvider implements IPlayerProvider {

  public async play(time?: number) {
    const playerApi = await PlayerFactory.getPlayerApi();
    if (time !== undefined) {
      await playerApi.seekVideoTo(time);
    }
    await playerApi.playVideo();
  }

  public async seek(time?: number) {
    const playerApi = await PlayerFactory.getPlayerApi();
    if (time !== undefined) {
      await playerApi.seekVideoTo(time);
    }
  }

  public async getCurrentTime(): Promise<number> {
    const playerApi = await PlayerFactory.getPlayerApi();
    return await playerApi.player.getCurrentTime();
  }

  public async pause() {
     const playerApi = await PlayerFactory.getPlayerApi();
     await playerApi.pauseVideo();
  }

  public static async getPlayer(): Promise<IYoutubePlayer> {
    const playerApi = await PlayerFactory.getPlayerApi();
    return playerApi.player;
  }

  public getTargetCaptions(): ICaptionsItem[] {
    return PlayerManager.getInstance().getTargetCaptions();
  }

  public async getActiveTargetCaptionIndex(): Promise<number> {
    const playerManager = PlayerManager.getInstance();
    return playerManager.getActiveTargetCaptionIndex();
  }

  public isPaused(): boolean {
    return getPlayerState(getState()) === PlayerStates.PAUSED
  }

  public isPlay(): boolean {
    const state = getPlayerState(getState())
    return state === PlayerStates.PLAYING || state === PlayerStates.BUFFERING;
  }

}

